import { Model, tProp, types } from "mobx-keystone";
import { cardNetworkNS } from "./ns";

@cardNetworkNS.model
export default class CardNetworkModel extends Model({
  name: tProp(types.string),
  svg: tProp(types.maybeNull(types.string)),
  enabled: tProp(types.maybeNull(types.boolean)),
}) {}
